/*
 * @Author: 孙照
 * @LastEditTime: 2024-01-04 14:39:08
 * @Description: 充电统计 vuex 模块
 * @FilePath: \sheyang\src\store\modules\chargingStat.js
 */
import { getStationDetail } from '@/api/overView/index';
import { getYesterdayOrTodayCharging, getChargeStatus, getDataStatistics } from '@/api/stationStatistics/index';
import { toDecimal } from '@/utils';

const GET_RANK_LIST = 'getRankList';
const GET_TODAY_DEGREE = 'getTodayDegree';
const GET_YESTERDAY_DEGREE = 'getYesterdayDegree';
const GET_PV_STATS = 'getPvStats';
const GET_STATION_DEGREE_INFO = 'getStationDegreeInfo'; // 获取单点站度数信息
const GET_BUS_ROAD_LIST = 'getBusRoadList'; // 获取公交路线列表

const charging = {
  namespaced: true,
  state: () => ({
    rankList: [], // top 10 充电数据
    todayDegree: 0, // 今日充电量
    yesterdayDegree: 0, // 昨日充电量
    pvStats: {}, // 光伏相关
    stationInfo: {}, // 单站点信息
    busRoadList: [], // 公交路线列表
  }),
  mutations: {
    [GET_RANK_LIST]: (state, commit) => {
      state.rankList = [...commit];
    },
    [GET_TODAY_DEGREE]: (state, commit) => {
      state.todayDegree = commit;
    },
    [GET_YESTERDAY_DEGREE]: (state, commit) => {
      state.yesterdayDegree = commit;
    },
    [GET_PV_STATS]: (state, commit) => {
      state.pvStats = commit;
    },
    [GET_STATION_DEGREE_INFO]: (state, commit) => {
      state.stationInfo = commit;
    },
    // 获取公交路线列表
    [GET_BUS_ROAD_LIST]: (state, commit) => {
      state.busRoadList = commit;
    },
  },
  actions: {
    // 获取充电TOP10，今日昨日充电量
    async rankAndYesterdayOrTodayData (context) {
      const res = await getYesterdayOrTodayCharging();
      const { code, data } = res;
      if (code === '200' && data) {
        const {
          rankingType,
          chargingDegrees,
          yesterdayDegrees,
          pvPowerGenerationF,
          pvPowerGenerationG,
          pvPowerGenerationJ,
          pvPowerGenerationP,
        } = data;
        const rankData = rankingType.map((v) => ({
          ...v,
          chargeCountRate: toDecimal(v.chargeCountRate * 100, 2),
          chargeCount: toDecimal(v.chargeCount, 2),
        }));
        const pvStats = {
          pvPowerGenerationF: toDecimal(pvPowerGenerationF),
          pvPowerGenerationG: toDecimal(pvPowerGenerationG),
          pvPowerGenerationP: toDecimal(pvPowerGenerationP),
          pvPowerGenerationTotal: toDecimal(pvPowerGenerationF) + toDecimal(pvPowerGenerationG) + toDecimal(pvPowerGenerationJ) + toDecimal(pvPowerGenerationP),
        };
        context.commit(GET_RANK_LIST, [...rankData]); // top 10 充电数据
        context.commit(GET_TODAY_DEGREE, Number(chargingDegrees)); // 今日充电量
        context.commit(GET_YESTERDAY_DEGREE, Number(yesterdayDegrees)); // 昨日充电量
        context.commit(GET_PV_STATS, pvStats); // 光伏相关
      }
    },
    // 查询场站信息 组合
    async getStationInfo (context, stubGroupId) {
      const stationInfo = {};
      // 昨日充电 今日充电
      const degreeRes = await getYesterdayOrTodayCharging({ stubGroupId });
      // 设备数量
      const qryRes = await getStationDetail({ stubGroupId });
      // 今日离线设备数、设备离线率 当前充电情况
      const statRes = await getChargeStatus({ stubGroupId });
      // 累计充电量、累计充电次数
      const staticsRes = await getDataStatistics({ stubGroupId });
      if (degreeRes.code === '200' && degreeRes.data) {
        const { yesterdayDegrees, chargingDegrees } = degreeRes.data;
        const { electricInternalTod, electricInternalTodYesterday } = staticsRes.data;
        stationInfo.yesterdayDegrees = yesterdayDegrees;
        stationInfo.chargingDegrees = chargingDegrees;
        stationInfo.electricInternalTodYesterday = electricInternalTodYesterday;
        stationInfo.electricInternalTod = electricInternalTod;
      }

      if (qryRes.code === '200' && qryRes.data) {
        const { equipmentNum, kwReal } = qryRes.data;
        // stationInfo.equipmentNum = equipmentNum;
        stationInfo.kwReal = kwReal;
      }

      if (statRes.code === '200' && statRes.data) {
        // console.log('----当前充电情况----', statRes.data);
        const {
          adcOffLine,
          adcOffLineRatio,
          adcCharging,
          adcFault,
          adcFree,
          rests,
        } = statRes.data;
        stationInfo.adcOffLine = adcOffLine;
        stationInfo.adcOffLineRatio = adcOffLineRatio;
        // stationInfo.equipmentNum = adcOffLineRatio ? Math.round(adcOffLine / adcOffLineRatio) : 0;
        stationInfo.equipmentNum = adcOffLine + adcCharging + adcFault + adcFree + rests;
      }
      if (staticsRes.code === '200' && staticsRes.data) {
        const { chargeAmount, chargingAmount } = staticsRes.data;
        stationInfo.chargeAmount = chargeAmount;
        stationInfo.chargingAmount = chargingAmount;
      }
      context.commit(GET_STATION_DEGREE_INFO, stationInfo);
    },
  },

  getters: {
    rankList: (state) => state.rankList,
    todayDegree: (state) => state.todayDegree,
    yesterdayDegree: (state) => state.yesterdayDegree,
    pvStats: (state) => state.pvStats,
    stationInfo: (state) => state.stationInfo,
  },
};

export default charging;
